export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// Break-glass recovery account: hidden from the admin user list and not allowed
// to change its own password from the UI.
export const RECOVERY_USER_EMAIL = "recovery@bliss.com";
//export const SERVER_URL='https://blissdatabase-trial-97a165e7193e.herokuapp.com/';
//export const SERVER_URL='http://localhost:8080/'
//export const SERVER_URL='https://greaterbase-6dd42b867f9c.herokuapp.com/';

// Booking-group status the HubSpot import stamps on a new group (en dash, U+2013).
// Plain string in campgroup_booking_meta.status like every other status.
export const IMPORTED_CHECK_STATUS = "Imported \u2013 check";

  export const STATUS = [
    { value: 'PROVISIONAL', label: 'PROVISIONAL' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'PAID', label: 'PAID' },
    ];

    export const ACCOUNTS = [
      { value: 'WISE', label: 'WISE' },
      { value: 'MONZO', label: 'MONZO' },
      { value: 'HSBC', label: 'HSBC' },
      { value: 'STRIPE', label: 'STRIPE' },
      { value: 'VOUCHER', label: 'VOUCHER' },
    ];
    
    export const ROLES = [
      { value: 'TEACHER', label: 'TEACHER' },
      { value: 'ACTIVITIES', label: 'ACTIVITIES' },
      { value: 'NIGHSHIFT', label: 'NIGHSHIFT' },
      { value: 'BOSS', label: 'BOSS'}
    ];

    export const CUTOFF_DATE = '2023-08-15';

// Which app this is, for the admin sessions list. The backend can infer it
// from the Origin, but both apps are localhost in development, so say it.
export const APP_CLIENT = "greaterbase";
